import React, { useEffect, useState } from "react";
import SplashScreen from "modules/UI/components/SplashScreen.component";
import StaticDataService from "../service/staticData.service";
import { INCOTERMS } from "service/generic.constants";
import { StaticData } from "../service/staticData.types";
import AdminService from "modules/Admin/service/admin.service";
import { CurrencyData } from "modules/PromoItems/services/promoItems.service";

export const StaticDataContext = React.createContext<StaticData>({
  spendCategories: [],
  spendCategoriesHashMap: {},
  businessUnits: [],
  languages: [],
  currencies: [],
  incoterms: [],
  incotermsHashMap: {},
  taxonomy: [],
  promoCategoryTypes: [],
});

export const StaticDataProvider = ({ children }) => {
  const [data, setData] = useState<StaticData>({
    spendCategories: [],
    spendCategoriesHashMap: {},
    businessUnits: [],
    languages: [],
    currencies: [],
    taxonomy: [],
    incotermsHashMap: INCOTERMS,
    incoterms: Object.keys(INCOTERMS).map((k) => ({
      id: k,
      name: INCOTERMS[k],
    })),
    promoCategoryTypes: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  // below code is to delete the filters stored in local storage on page refresh. can be deleted if it needs to be retained
  localStorage.removeItem("browse_filters");
  localStorage.removeItem("list_filters0");
  localStorage.removeItem("list_filters1");
  localStorage.removeItem("list_filters2");

  const init = async () => {
    try {
      const spendCategories = await StaticDataService.fetchCategoryTree();
      const spendCategoriesHashMap = spendCategories.reduce((acc, curr) => {
        acc[curr.id] = curr;
        if (curr.spendCategories) {
          curr.spendCategories.forEach((spendCatL2) => {
            acc[spendCatL2.id] = spendCatL2;
            if (spendCatL2.spendCategories) {
              spendCatL2.spendCategories.forEach((spendCatL3) => {
                acc[spendCatL3.id] = spendCatL3;
              });
              // delete spendCatL2.spendCategories;
            }
          });
          // delete curr.spendCategories;
        }

        return acc;
      }, {});
      const businessUnits = await StaticDataService.fetchBusinessUnits();
      const languages = await StaticDataService.fetchLanguages();
      const initialcurrencies = await StaticDataService.fetchAllCurrencies();
      const currencies = await initialcurrencies?.map(item => CurrencyData.FromBackend(item));
      const taxonomyResponse: any[] = await AdminService.getAllPromoCategories();
      const taxonomy = taxonomyResponse.filter(item => !item.isDeleted);
      const promoCategoryTypes = await StaticDataService.fetchPromoCategoryTypes();
      setData({
        ...data,
        currencies,
        spendCategories,
        spendCategoriesHashMap,
        businessUnits,
        languages,
        taxonomy,
        promoCategoryTypes,
      });
    } catch (e) {
      console.log({ error: e });
      setError(e);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    init();
  }, []);
  return (
    <StaticDataContext.Provider value={data}>
      {" "}
      <SplashScreen
        message="Loading Resources..."
        status={isLoading ? "loading" : error ? "error" : "idle"}
      />
      {!isLoading && !error && children}
      {/* <pre><code>{JSON.stringify(ctx.spendCategoriesHashMap, null, 3)}</code></pre> */}
    </StaticDataContext.Provider>
  );
};
